export const findRef = {
  methods: {
    findRefByName (refName) {
      let obj = this
      while (obj) {
        if (obj.$refs[refName]) {
          return obj.$refs[refName]
        }
        obj = obj.$parent
      }
      return undefined
    }
  }
}
